import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // Determine if we're on the homepage or not
  const isHomePage = window.location.pathname === '/';
  const navItems = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Why Attend',
    href: '#why-attend'
  }, {
    name: 'Agenda',
    href: '#agenda'
  }, {
    name: 'Venue',
    href: '#venue'
  }, {
    name: 'Register',
    href: '#register'
  }, {
    name: 'Sponsorship',
    href: '/sponsorship'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (isHomePage && href.startsWith('#')) {
      e.preventDefault();
      const element = document.getElementById(href.substring(1));
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      setIsMenuOpen(false);
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#FFF8DC] shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-104" data-mp="3fasuvb6n5eag">
      <div className="container mx-auto px-4 md:px-6" data-id="element-105" data-mp="35kr6sjeafvvj">
        <div className="flex items-center justify-between" data-id="element-106" data-mp="35jg64sg5348n">
          <div className="flex items-center" data-id="element-107" data-mp="30loc9svxp81t">
            <Link to="/" data-id="element-108" data-mp="30kljfff1wvj9">
              <h1 className={`text-xl font-bold font-serif tracking-wide ${isScrolled ? 'text-[#8B4513]' : 'text-white'}`} style={{
              fontFamily: 'Rockwell, "Courier New", serif'
            }} data-id="element-109" data-mp="1wzcai6xfphp">
                COMMERCE CFO ROUNDTABLE - AUSTIN
              </h1>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-110" data-mp="1ho9tgr4g47a1">
            {navItems.map(item => <Link key={item.name} to={item.href.startsWith('#') ? '/' : item.href} onClick={e => handleNavClick(e, item.href)} className={`font-medium hover:text-[#D2691E] transition-colors ${isScrolled ? 'text-[#556B2F]' : 'text-white'}`} data-id="element-111" data-mp="1mmbcxd5sa8m1">
                {item.name}
              </Link>)}
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-112" data-mp="13oilb70m1l3y">
            {isMenuOpen ? <X className={isScrolled ? 'text-[#8B4513]' : 'text-white'} size={24} data-id="element-113" data-mp="2y29vc7muq6zx" /> : <Menu className={isScrolled ? 'text-[#8B4513]' : 'text-white'} size={24} data-id="element-114" data-mp="mck6azj8j2rh" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden absolute left-0 right-0 top-full bg-[#FFF8DC] shadow-md p-4 border-t border-[#D2691E]" data-id="element-115" data-mp="rd7w5hvq9dk4">
            <div className="flex flex-col space-y-4" data-id="element-116" data-mp="153uqkxugghae">
              {navItems.map(item => <Link key={item.name} to={item.href.startsWith('#') ? '/' : item.href} onClick={e => handleNavClick(e, item.href)} className="text-[#556B2F] font-medium hover:text-[#D2691E] transition-colors" data-id="element-117" data-mp="1059pyxbajvlf">
                  {item.name}
                </Link>)}
            </div>
          </div>}
      </div>
    </header>;
}